import type { CSSProperties } from 'react'

// Using solid colors since CSS variables don't work reliably in inline styles
// Light theme: white background, dark text
// Dark theme colors would need to be handled via a theme context if needed

export const positionerStyle: CSSProperties = {
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  zIndex: 9999,
}

export const animatorStyle: CSSProperties = {
  maxWidth: '600px',
  width: '100%',
  backgroundColor: '#ffffff',
  color: '#1a1a1a',
  borderRadius: '12px',
  overflow: 'hidden',
  boxShadow: '0 16px 70px rgba(0, 0, 0, 0.3)',
  border: '1px solid #e5e5e5',
}

export const searchStyle: CSSProperties = {
  padding: '16px 20px',
  fontSize: '16px',
  width: '100%',
  boxSizing: 'border-box',
  outline: 'none',
  border: 'none',
  backgroundColor: '#ffffff',
  color: '#1a1a1a',
  borderBottom: '1px solid #e5e5e5',
}

export const groupNameStyle: CSSProperties = {
  padding: '8px 20px',
  fontSize: '11px',
  textTransform: 'uppercase',
  color: '#666666',
  letterSpacing: '1px',
  fontWeight: 600,
  backgroundColor: '#ffffff',
}

export const resultItemStyle = (active: boolean): CSSProperties => ({
  padding: '12px 20px',
  backgroundColor: active ? '#f5f5f5' : '#ffffff',
  borderLeft: active ? '3px solid #3b82f6' : '3px solid transparent',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  cursor: 'pointer',
  transition: 'all 0.15s ease',
})

export const shortcutContainerStyle: CSSProperties = {
  display: 'flex',
  gap: '4px',
}

export const shortcutKeyStyle: CSSProperties = {
  padding: '4px 8px',
  backgroundColor: '#f0f0f0',
  borderRadius: '4px',
  fontSize: '11px',
  color: '#666666',
}
